import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '新潟空港からチャチャチャッと全国へ！ | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="県からのお知らせ" />
      <SectionTitle sectionTitle="新潟空港からチャチャチャッと全国へ！" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023秋号 No.164 目次",
                path: "/no164"
              },
              {
                name: "県からのお知らせ"
              }
            ]}
          />
        
        <h3 css={style.subTitle01}>飛びっきりチカづけニッポン！キャンペーン</h3>
        
        <p>期間中、新潟空港発着の国内線を往復で利用し、アンケートにお答えいただいた方の中から抽選で「飛びっきりの選べるごほうび」をプレゼント！<br />キャンペーンアンバサダーのチカコホンマさんが皆さんの旅を応援します！</p>
        
        <div>
          <img
            src={`${basePath}/no164/img/2-27.png`}
            alt="チカコホンマさん"
            css={style.img(200)}
          />
        </div>
        
        <p><span css={style.emphasisWeight}>期間</span>&emsp;11月1日（水）～令和6年1月31日（水）</p>
        <p><span css={style.emphasisWeight}>賞品</span></p>
        <ul>
          <li><span css={style.emphasisWeight}>A賞【ペア3組】</span>&emsp;憧れのホテル･旅館宿泊券（10万円相当）</li>
          <li><span css={style.emphasisWeight}>B賞【ペア10組】</span>&emsp;1ランク上のホテル･旅館宿泊券（5万円相当）</li>
          <li><span css={style.emphasisWeight}>C賞【10名様】</span>&emsp;就航地の味わう贅沢直送便（1万円相当）</li>
          <li><span css={style.emphasisWeight}>Wチャンス</span>&emsp;はずれた方の中から抽選で30名様に国内線就航各航空会社オリジナルギフト（新潟空港ファンクラブ会員限定）</li>
        </ul>
        
        <br />
        
        <p>事業主体：新潟空港整備推進協議会</p>
        
        <p>詳しくは
          <a
            href="https://www.niigata-airport.gr.jp/campaign/chikapon/"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
          から
        </p>
        
        <div>
          <img
            src={`${basePath}/no164/img/2-28.png`}
            alt="新潟空港　チカポン　検索"
            css={style.img(253)}
          />
        </div>
        
        <p>【問い合わせ】空港課&emsp;電話：<a href="tel:025-280-5865">025-280-5865</a></p>
        
        <BackBtn href={"/no164"} />
      </Content>
    </Page>
  )
}
export default Home
